import useAuthState from '@/states/auth.state';

export interface UnifiedUserInfo {
  id: string;
  name: string;
  email: string;
  username?: string;
  avatar_url?: string | null;
  is_admin?: boolean;
}

/**
 * Get unified user information from keycloak-js backend profile
 */
export const useUnifiedUserInfo = (): UnifiedUserInfo | null => {
  const { userProfile, keycloakUserInfo } = useAuthState();

  if (keycloakUserInfo) {
    return {
      id: String(keycloakUserInfo.id),
      name: keycloakUserInfo.name,
      email: keycloakUserInfo.email,
      username: keycloakUserInfo.email,
      avatar_url: keycloakUserInfo.avatar_url,
      is_admin: false,
    };
  }

  if (userProfile) {
    return {
      id: userProfile.id.toString(),
      name: userProfile.name,
      email: userProfile.email,
      username: userProfile.email,
      avatar_url: userProfile.avatar_url,
      is_admin: userProfile.is_admin,
    };
  }

  return null;
};

/**
 * Get user email for API calls that require username/email
 */
export const useUserEmail = (): string | null => {
  const userInfo = useUnifiedUserInfo();
  return userInfo?.email || null;
};

/**
 * Get user display name
 */
export const useUserDisplayName = (): string | null => {
  const userInfo = useUnifiedUserInfo();
  return userInfo?.name || null;
};

/**
 * Check if user is admin (only available for AlurKerja SSO)
 */
export const useIsUserAdmin = (): boolean => {
  const userInfo = useUnifiedUserInfo();
  return userInfo?.is_admin || false;
};

/**
 * Get avatar URL (only available for AlurKerja SSO)
 */
export const useUserAvatarUrl = (): string | null => {
  const userInfo = useUnifiedUserInfo();
  return userInfo?.avatar_url || null;
};